import { EditorProps } from 'react-data-grid'

import { memo, useEffect, useState } from 'react'

import { DgtPdMovementReason } from '../models'

import { SummaryRow } from '../constants/Column'

import Select from 'react-select';

import { DataStore, SortDirection } from '@aws-amplify/datastore'

import { MovementType } from '../constants/EnumType';

import { OrderPicklistMovement } from './types';
import Modal from './Modal';
import { formatNumberV2 } from '../utilities/Format';

function getAfterWord(inputString: string, spliceWord: string) {
  const parts = inputString.split(spliceWord);
  return parts[1];
}

export default memo(function ModalMvResEditor({ props } : {
  props: EditorProps<OrderPicklistMovement, SummaryRow>
}) {
  const { row, onRowChange, onClose } = props

  const [movementReasons, setMovementReasons] = useState<DgtPdMovementReason[]>([]);

  useEffect(() => {
    const getMovementReasons = async () => {
      const mvReas = await DataStore.query(
        DgtPdMovementReason, s => s
          .movementType("eq", MovementType.RETURN)
          .componenType('eq', row.materialType === 'RAW' ? 'RM':'PK')
          .active('eq', true)
          ,{
            sort: s => s.reasonCode(SortDirection.ASCENDING)
          }
        )
      
      setMovementReasons(mvReas)
    }
    getMovementReasons()
  }, [ row ])

  return <Modal show={true} onHide={onClose}
    okTheme='info'
    okText='เลือก'
    okAction={() => {
      onRowChange(row, true)
    }}
    cancelText='ปิด'
    title={`เลือกเหตุผลคืนของ ${row.materialCode} - ${row.materialDescription}`}
    maxWidth={'max-w-xl'}
  >
    <>
      <div className='flex justify-between '>
        <h6 className=" before:content-['Lot:'] before:mr-2">{row.batchLotNo}</h6>
        <>
          {row.returnGoodQty! > 0 && <h6 className=" before:content-['คืนดี'] before:mr-2">{formatNumberV2(row.returnGoodQty)} {row.materialUnit}</h6>}
          {row.returnGoodShrinkQty! > 0 && <h6 className=" before:content-['คืนดีติดSTK'] before:mr-2">{formatNumberV2(row.returnGoodShrinkQty)} {row.materialUnit}</h6>}
          {row.returnWasteQty! > 0 && <h6 className=" before:content-['คืนเสีย'] before:mr-2">{formatNumberV2(row.returnWasteQty)} {row.materialUnit}</h6>}
        </>
      </div>
      <Select
        classNamePrefix='select'
        isSearchable={false}
        value={row.returnReasonCode ? { 
          label: `${row.returnReasonCode} - ${row.returnReasonDescription}`, 
          value: row.returnReasonCode 
        } : null}
        options={movementReasons.map(res => (
          {
            label: `${res.reasonCode} - ${res.reasonDesciption}`, 
            value: res.reasonCode
          }
        ))}
        menuPortalTarget={document.body}
        styles={{ 
          menuPortal: base => ({ ...base, zIndex: 9999 })
        }}
        placeholder='เลือกเหตุผลคืน...'
        onChange={(e: any) => onRowChange({ 
          ...row, 
          returnReasonCode: e.value,
          returnReasonDescription: getAfterWord(e.label, ' - ')
        })}
      />
    </>
  </Modal>
})